import { useCallback, useEffect, useState } from "react";
import { RoundLive } from "../interfaces/IRoundsLive";
import { findRoundLiveById, subscribeRoundLiveById } from "../services/roundsService";

export const useRoundLive = (
  competitionId: string | undefined,
  categoryId: string | undefined,
  roundId: string | undefined,
  enabled = true,
) => {
  const [round, setRound] = useState<RoundLive | null>(null);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);

  const canLoad = Boolean(enabled && competitionId && categoryId && roundId);

  const refreshRound = useCallback(async () => {
    if (!canLoad) {
      setRound(null);
      setLoading(false);
      setError(null);
      return;
    }

    setLoading(true);
    setError(null);
    try {
      const data = await findRoundLiveById(competitionId!, categoryId!, roundId!);
      setRound(data);
    } catch (err) {
      setError(err instanceof Error ? err.message : "Wystąpił błąd podczas odczytu rundy.");
    } finally {
      setLoading(false);
    }
  }, [canLoad, competitionId, categoryId, roundId]);

  useEffect(() => {
    if (!canLoad) {
      setRound(null);
      setLoading(false);
      setError(null);
      return;
    }

    setLoading(true);
    setError(null);

    const unsubscribe = subscribeRoundLiveById(
      competitionId!,
      categoryId!,
      roundId!,
      (data) => {
        setRound(data);
        setLoading(false);
      },
      (err) => {
        setError(err.message);
        setLoading(false);
      },
    );

    return () => unsubscribe();
  }, [canLoad, competitionId, categoryId, roundId]);

  return {
    round,
    loading,
    error,
    refreshRound,
  };
};
